import { PublicUser } from '@pixacare/domain';
import { ExaminationResponse } from '@pixacare/dtos';
import { StoreExamination } from '../models/store-examination';

export const examinationResponseToStoreExamination = (examination: ExaminationResponse): StoreExamination =>
  ({
    ...examination,
    createdByInstance: undefined,
    updatedByInstance: undefined,
    examinationForm: undefined,
  }) as StoreExamination;

export const storeExaminationToExaminationResponse = (
  examination: StoreExamination,
  createdByInstance: PublicUser,
  updatedByInstance?: PublicUser,
): ExaminationResponse =>
  ({
    ...examination,
    createdByInstance,
    updatedByInstance,
    examinationForm: undefined,
  }) as ExaminationResponse;
